import React, { Suspense, useMemo } from 'react'
import { Provider, useSelector } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { SnackbarProvider } from 'notistack'
import { PersistGate } from 'redux-persist/integration/react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import { store, persistor } from '../store/store'
import { createAdminTheme } from '../theme'
import AppRoutes from './AppRoutes'

function ThemeBridge({ children }) {
  const mode = useSelector((s) => s.uiShell.mode)
  const theme = useMemo(() => createAdminTheme(mode), [mode])
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

function BootFallback() {
  return (
    <Box minHeight="40vh" display="flex" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Box>
  )
}

export default function AppProviders() {
  return (
    <Provider store={store}>
      <PersistGate loading={<BootFallback />} persistor={persistor}>
        <ThemeBridge>
          <SnackbarProvider maxSnack={3}>
            <BrowserRouter basename={process.env.PUBLIC_URL?.replace(/\/$/, '') || undefined}>
              <Suspense fallback={<BootFallback />}>
                <AppRoutes />
              </Suspense>
            </BrowserRouter>
          </SnackbarProvider>
        </ThemeBridge>
      </PersistGate>
    </Provider>
  )
}
